﻿window._us = _.noConflict();